import { ReactElement, memo } from 'react';
import * as S from './ErrorMessage.styles';

type ErrorMessageProps = {
    message: string;
};

export const ErrorMessageContainer = ({ message }: ErrorMessageProps): ReactElement => {
    return (
        <S.ErrorText>
            <S.ErrorIcon />
            {message}
        </S.ErrorText>
    );
};

export const ErrorMessage = memo(ErrorMessageContainer);
